// extracted by mini-css-extract-plugin
export default {"title":"PizzaList_title__hmI84","pizzaList":"PizzaList_pizzaList__3iUNv","pizzaCard":"PizzaList_pizzaCard__RuT1v"};